import ProjectHeaderContainer from "../../components/common/ProjectHeaderContainer";
import ProjectViewerContainer from "../../components/project/ProjectViewerContainer"



const ProjectViewerPage = () => {
    return (
        <>
            <ProjectHeaderContainer />
            <ProjectViewerContainer />
        </>
    );
};

export default ProjectViewerPage;